import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { EigentumanteilMasterDetailEntryMeta, GbeigentumService, GrundstueckId } from '../../core/gb-api';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { NavTarget } from '../../shared/components/link/link.component';
import { TimepointCtx, TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormatConfigService } from '../../core/services/format-config.service';
import { map } from 'rxjs/operators';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { BeschreibungTableWrapperComponent } from '../../shared/components/table/beschreibung-table-wrapper.component';
import { FormatBelegPipe } from '../../shared/pipes/format/format-beleg.pipe';
import { KompaktGrundstueckComponent } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { OrderByGrundstuecknummerPipe } from '../../shared/pipes/order/order-by-grundstuecknummer.pipe';
import { HistoryDirective } from '../../shared/directives/history.directive';
import { NgTemplateOutlet } from '@angular/common';
import { Subscription } from 'rxjs';
import { EigentumanteilMasterDetailVM } from '../../shared/services/eigentumanteil/eigentumanteil-master-detail-vm.service';
import { RechtsgrundIcpComponent } from '../shared/component/rechtsgrund-icp/rechtsgrund-icp.component';

@Component({
  selector: 'cap-dominierte-grundstuecke-icp',
  imports: [
    BeschreibungTableWrapperComponent,
    FormatBelegPipe,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    ListLoaderWrapperComponent,
    OrderByGrundstuecknummerPipe,
    TranslatePipe,
    HistoryDirective,
    NgTemplateOutlet,
    RechtsgrundIcpComponent
  ],
  templateUrl: './dominierte-grundstuecke-icp.component.html'
})
export class DominierteGrundstueckeIcpComponent extends AbstractComponent implements OnInit, OnDestroy, OnChanges {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<EigentumanteilMasterDetailVM>;
  historischeDatenSubscription: Subscription;
  rechtsgrundDatumAnzeigen: boolean = true;
  belegeAnzeigen: boolean = false;

  @Input()
  navigateTo: NavTarget = NavTarget.NAV_GRUNDSTUECK;

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  constructor(
    private eigentumService: GbeigentumService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private translateService: TranslateService,
    private appformatConfigService: FormatConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    this.appformatConfigService.parameterConfig$.subscribe((config) => {
      this.rechtsgrundDatumAnzeigen = <any>config?.parameters.ERWERBSDATUM_ANZEIGEN;
      this.belegeAnzeigen = <any>config?.parameters.BELEGEANZEIGEN;
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
    this.listLoader.unsubscribeAll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update(): void {
    const timepointCtx: TimepointCtx = this.timepointService.timepointCtx;

    const observable = this.eigentumService
      .loadEigentumSichtGrundstueck(
        //
        this._grundstueckId.id, //
        false, //
        'BERECHTIGT_SUBJEKTIV_DINGLICH', //
        this.appConfigService.einstellungHistorischeDaten, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId //
      )
      .pipe(map((r) => this.crateViewModel(r.entries)));
    this.listLoader = new ListLoaderObservable<EigentumanteilMasterDetailVM>(undefined, 1, observable);
  }

  crateViewModel(entries: EigentumanteilMasterDetailEntryMeta[]): EigentumanteilMasterDetailVM[] {
    const eigentumArray = [];
    for (const entry of entries) {
      eigentumArray.push(new EigentumanteilMasterDetailVM(entry, this.translateService));
    }
    return eigentumArray;
  }
}
